import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { DocumentosProjeto } from '../models/documentos-projeto.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocumentosProjetoService extends BaseService<DocumentosProjeto> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/projetos/documentos';
  }

  public updateDocumento(obj, id: number): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/' + id, obj);
  }

  public createDocumento(obj): Observable<DocumentosProjeto> {
    return this.http.post<DocumentosProjeto>(this.baseUrl, obj);
  }

  public download(id: number): Observable<HttpResponse<Blob>> {
    return this.http.get(this.baseUrl + "/download/" + id, {
      headers: this.headers,
      responseType: 'blob',
      observe: 'response'
    })
  }

  extractFilename(contentDispositionHeader: string): string | null {
    const matches = contentDispositionHeader.match(/filename\*=(?:UTF-8['']?)?([^;\r\n]*)/i);
    if (matches && matches.length > 1) {
      let encodedFilename = matches[1].trim();
      return decodeURIComponent(encodedFilename);
    }
    return null;
  }
  
	public resolveAccordAndRedir(paramsObj: DocumentosProjeto): Promise<any> {
		let params = new HttpParams();
		for (const key in paramsObj) {
			params = params.append(key, paramsObj[key]);	
		}
		return new Promise((resolve, reject) => {
			this.http.get<any>(this.baseUrl + '/resolve-accord-and-redir',
				{ headers: this.headers, params: params }
			).subscribe({
				next: data => resolve(data),
				error: err => reject(err)
			});
		});
	}
	
	public list(paramsObj: DocumentosProjeto): Promise<any> {
		let params = new HttpParams();
		for (const key in paramsObj) {
			params = params.append(key, paramsObj[key]);	
		}
		return new Promise((resolve, reject) => {
			this.http.get<any>(this.baseUrl + '/list',
				{ headers: this.headers, params: params }
			).subscribe({
				next: data => resolve(data),
				error: err => reject(err)
			});
		});
	}
}
